<!--  -->
<template>

  <div ref="replace" class="img-back">
    <div>
      <img v-if="currentBgType == 'img'" class="bg-img" :src="currentBgImg">
      <video
        v-if="currentBgType == 'video'"
        ref="video"
        :src="currentBgVideo"
        autoplay
        loop
        preload
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x-webkit-airplay="allow"
        webkit-playsinline
        playsinline
        class="video"
      />
      <div class="right-header">
        <span @click="goHome">大会主界面</span>
        <span>|</span>
        <span @click="goPage">首页</span>
        <span>|</span>
        <span @click="gototal">产品展示</span>
        <span>|</span>
        <span @click="goIndustry">行业案例</span>
      </div>
      <div v-if="currentData.btns.length > 0">
        <div
          v-for="(div, index) in currentData.btns"
          :key="index"
          class="btn-div"
          :style="getStyle(div)"
          @click="clickDiv(div.action)"
        />
      </div>
      <!-- 弹出框 -->
      <product @divClose="divClose" />
      <total ref="total" @chanageImg="chanageImg" @divClose="divClose" />
      <overall @divClose="oveDivClose" />
      <industry @divClose="divClose" @chanageImg="chanageImg" />
      <indoverall @divClose="oveDivClose" />
    </div>
    <!-- 如果是移动端就显示遮罩提示层 -->
    <oriScreenTip />
    <!-- <div v-if="zhezhaoFather" class="zhezhaoFather">
      <div class="zhezhao" @click="divClick" />
    </div> -->
    <template>
      <div v-if="showClickTips" class="playerTips" @click="initVideo">
        <div>
          <img src="http://hpc.devotedigital.cn/resources/img/first-click.png">
        </div>
      </div>
    </template>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import product from '@com/Popup/Product'
import total from '@com/Popup/Total'
import overall from '@com/Popup/overall/Overall.vue'
import indoverall from '@com/Popup/overall/IndOverall.vue'
import industry from '@com/Popup/Industry'
import oriScreenTip from '@com/OriScreenTip/OriScreenTip'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    product,
    total,
    overall,
    industry,
    indoverall,
    oriScreenTip
  },
  data() {
    // 这里存放数据
    return {
      jsonData: new Map(),
      currentData: {
        btns: [],
        img_bg: ''
      },
      currentBgImg: '',
      json: null,
      // 存放渲染div数组
      indexBtn: [],
      oldbtn: [],
      divBtn: [],
      // 判断
      iftrue: false,
      // 视频
      currentBgVideo: '',
      // 背景显示
      currentBgType: '',
      // 判断背景有无cover
      havecoveur: true,
      zhezhaoFather: false,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      showClickTips: true
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initJson()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  // 方法集合
  methods: {
    initJson() {
      this.json = require('@media/data.json')
      this.json.pages.forEach((item) => {
        this.jsonData.set(item.name, item)
      })
      this.currentData = this.json.index
      this.currentBgVideo = this.json.index.img_bg
      this.currentBgType = this.json.index.bg_type
      this.divBtn = this.jsonData.get('second').btns
      this.indexBtn = this.json.index.btns
    },
    getStyle(data) {
      return {
        left: (data.left / 1920) * 100 + '%',
        top: (data.top / 1080) * 100 + '%',
        width: (data.width / 1080) * 100 + '%',
        height: (data.height / 1080) * 100 + '%'
      }
    },
    chanageImg(dataImg) {
      this.currentBgImg = dataImg
    },
    oveDivClose(dataImg) {
      this.currentBgImg = dataImg
    },
    clickDiv(action) {
      switch (action.type) {
        case 'page':
          this.currentData = this.jsonData.get(action.target)
          if (this.iftrue) {
            this.iftrue = false
            this.currentData.btns = this.oldbtn
          }
          if (this.currentData.btns.length === 1) {
            this.currentData.btns = this.divBtn
          }
          this.currentBgImg = this.jsonData.get(action.target).img_bg
          this.currentBgType = this.jsonData.get(action.target).bg_type
          // 当循环div没有数据时，重新赋值
          if (this.currentData.btns.length === 0) {
            this.currentData.btns = this.divBtn
          }
          break
        case 'pop':
          this.oldbtn = this.currentData.btns
          this.currentData.btns = []
          if (action.target === 'about') {
            this.$store.commit('customModule/setProduct', true)
            this.currentBgImg = this.jsonData.get(action.target).img_bg
          }
          if (action.target === 'production') {
            this.$store.commit('customModule/setTotal', true)
            this.$store.commit('customModule/setFourDivShow', true)
            this.currentBgImg = this.jsonData.get(action.target).img_bg
            // 初始化每次都是四个div
            const data = this.$refs.total.divData
            this.$refs.total.divData = data
          }
          if (action.target === 'case') {
            this.$store.commit('customModule/setIndustry', true)
            this.currentBgImg = this.jsonData.get(action.target).img_bg
            if (this.$store.state.customModule.imgArray[0] === 'left0') {
              this.$store.commit(
                'customModule/setIndustryImgShow',
                'rightHide'
              )
            } else if (this.$store.state.customModule.imgArray[1] === 'left3') {
              this.$store.commit('customModule/setIndustryImgShow', 'leftHide')
            } else {
              this.$store.commit('customModule/setIndustryImgShow', 'notHide')
            }
          }
          break
      }
    },
    // 点击X号后恢复div
    divClose() {
      this.currentData.btns = this.divBtn
      this.currentBgImg = this.jsonData.get('second').img_bg
    },
    // 返回首页
    goHome() {
      this.currentData.btns = this.indexBtn
      this.currentBgVideo = this.json.index.img_bg
      this.currentBgType = this.json.index.bg_type
      if (
        this.$store.state.customModule.product === true ||
        this.$store.state.customModule.total === true
      ) {
        this.iftrue = true
      }
      this.allClose()
      this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      // 使得返回展示厅时显示开启华为之旅
      this.showClickTips = true
    },
    // 返回主页
    goPage() {
      this.currentBgType = this.jsonData.get('second').bg_type
      // //
      if (
        this.$store.state.customModule.product === true ||
        this.$store.state.customModule.total === true
      ) {
        this.iftrue = true
        this.currentData.btns = this.divBtn
        this.currentBgImg = this.jsonData.get('second').img_bg
        this.allClose()
      } else {
        this.currentData = this.jsonData.get('second')
        this.currentData.btns = this.divBtn
        this.currentBgImg = this.jsonData.get('second').img_bg
        this.allClose()
      }
      this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
    },
    // 前往产品展示
    gototal() {
      this.currentBgType = this.jsonData.get('production').bg_type
      this.currentBgImg = this.jsonData.get('production').img_bg
      this.currentData.btns = []
      this.$store.commit('customModule/setTotal', true)
      this.$store.commit('customModule/setFourDivShow', true)
      this.$store.commit('customModule/setIndOverall', false)
      this.$store.commit('customModule/setoverallImgArrayClear')
      this.$store.commit('customModule/setIndoverallImgArrayClear')
      const data = this.$refs.total.divData
      this.$refs.total.divData = data
      //
      if (this.$store.state.customModule.total) {
        this.$store.commit('customModule/setIndustry', false)
        this.$store.commit('customModule/setProduct', false)
      }
      this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
    },
    // 案例演示
    goIndustry() {
      this.currentBgType = this.jsonData.get('case').bg_type
      this.currentBgImg = this.jsonData.get('case').img_bg
      this.currentData.btns = []
      this.$store.commit('customModule/setIndustry', true)
      this.$store.commit('customModule/setIndOverall', false)
      this.$store.commit('customModule/setoverallImgArrayClear')
      this.$store.commit('customModule/setIndoverallImgArrayClear')
      if (this.$store.state.customModule.industry) {
        this.$store.commit('customModule/setTotal', false)
        this.$store.commit('customModule/setProduct', false)
        this.$store.commit('customModule/setoverall', false)
      }
      // 判断左右按钮显示
      if (this.$store.state.customModule.imgArray[0] === 'left0') {
        this.$store.commit('customModule/setIndustryImgShow', 'rightHide')
      } else if (this.$store.state.customModule.imgArray[1] === 'left3') {
        this.$store.commit('customModule/setIndustryImgShow', 'leftHide')
      } else {
        this.$store.commit('customModule/setIndustryImgShow', 'notHide')
      }
      //
    },
    // 所有组件呈现关闭状态
    allClose() {
      this.$store.commit('customModule/setProduct', false)
      this.$store.commit('customModule/setTotal', false)
      this.$store.commit('customModule/setoverall', false)
      this.$store.commit('customModule/setIndOverall', false)
      this.$store.commit('customModule/setIndustry', false)
      this.$store.commit('customModule/setoverallImgArrayClear')
      this.$store.commit('customModule/setIndoverallImgArrayClear')
    },
    divClick() {
      // var conW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      // var conH = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      this.zhezhaoFather = false
      this.$refs.replace.className = 'img-replace'
    },
    initVideo() {
      this.showClickTips = false
      try {
        this.$refs.video.play()
      } catch (e) {
        //
      }
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>

.img-back {
  width: 100vw;
  height: 100vh;
  // 遮罩
}
.img-replace {
  width: 100vh;
  height: 100vw;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-transform: translate(-50%, -50%) rotate(90deg);
  transform: translate(-50%, -50%) rotate(90deg);
  -webkit-touch-callout: none;
}
.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
  display: block;
  // min-width: 1100px;
  object-fit: cover;
  // border:1px solid transparent;
}
.bg-cover {
  object-fit: cover;
}
.video {
  position: absolute;
  object-fit: cover;
  /* px-to-viewport-ignore-next */
  // min-width: 1100px;
  // right: 0px;
  // bottom: 0px;
  height: 100%;
  width: 100%;
  // background-size: cover
}
.right-header {
  position: absolute;
  top: 7%;
  right: 6%;
  width: 20%;
  height: 20%;
  // min-width: 200px;
  span {
    color: #ffffff;
    margin-right: 0.8vw;
    font-size: 0.88vw;
    cursor: pointer;
  }
  span:nth-of-type(even) {
    cursor: Default;
  }
}
.btn-div {
  cursor: pointer;
  position: absolute;
  // background-color: red;
}
.zhezhaoFather {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: black;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  .zhezhao {
    position: absolute;
    width: 300px;
    height: 300px;
    background: blanchedalmond;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    cursor: pointer;
  }
}
span:nth-child(1) {
  position: absolute;
  left: -39%;
  top: 0%;
  width: 50%;
  height: 50%;
}
span:nth-child(2) {
  position: absolute;
  left: -8%;
  top: 0%;
  width: 50%;
  height: 50%;
}
span:nth-child(3) {
  position: absolute;
  left: -2%;
  top: 0%;
  width: 50%;
  height: 50%;
}
span:nth-child(4) {
  position: absolute;
  left: 13%;
  top: 0%;
  width: 50%;
  height: 50%;
}
span:nth-child(5) {
  position: absolute;
  left: 20%;
  top: 0%;
  width: 50%;
  height: 50%;
}
span:nth-child(6) {
  position: absolute;
  left: 46%;
  top: 0%;
  width: 50%;
  height: 50%;
}
span:nth-child(7) {
  position: absolute;
  left: 53%;
  top: 0%;
  width: 50%;
  height: 50%;
}
.playerTips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('http://hpc.devotedigital.cn/resources/img/first-click-bg.png') no-repeat;
  background-size: 100% 100%;
  display: table;
  text-align: center;
  z-index: 999;
  div {
    font-size: 20px;
    opacity: 0.8;
    color: white;
    display: table-cell;
    vertical-align: middle;
    animation: flush 2s infinite ease-in;
    text-align: center;
    img {
      pointer-events: none;
      height: 70px;
    }
  }
}
@keyframes flush {
  0% {
    opacity: 0.3;
    transform: scale(1.2);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 0.3;
    transform: scale(1.2);
  }
}
</style>
